(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maine-coon-polaroids"] && !Shopify.designMode) return;
  try {
    
  const initializePolaroidCarousel = (section) => {
    if (!section || section.dataset.carouselReady === 'true') return;

    const inner = section.querySelector('.customer-polaroids__inner');
    const track = section.querySelector('[data-polaroid-track]');
    const cards = track ? Array.from(track.querySelectorAll('.customer-polaroids__card')) : [];
    const dotsContainer = section.querySelector('[data-polaroid-dots]');
    const previousButton = section.querySelector('[data-polaroid-previous]');
    const nextButton = section.querySelector('[data-polaroid-next]');

    if (!inner || !track || cards.length === 0) return;
    section.dataset.carouselReady = 'true';

    let dots = [];
    let pageCount = 1;
    let visibleCards = 1;
    let currentPage = 0;
    let isProgrammaticScroll = false;
    let programmaticScrollTimer;

    const isMobile = () => window.matchMedia('(max-width: 549px)').matches;
    const sliderEnabled = () => isMobile()
      ? inner.dataset.mobileLayout === 'slider'
      : inner.dataset.desktopLayout === 'slider';

    const getVisibleCards = () => Math.max(1, Number(
      isMobile() ? inner.dataset.mobileVisible : inner.dataset.desktopVisible
    ) || 1);

    const getStepWidth = () => {
      if (!cards[0]) return track.clientWidth;
      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    };

    const setActivePage = (page) => {
      const safePage = Math.max(0, Math.min(pageCount - 1, page));
      dots.forEach((dot, index) => {
        const active = index === safePage;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (previousButton) previousButton.disabled = safePage === 0;
      if (nextButton) nextButton.disabled = safePage === pageCount - 1;
    };

    const goToPage = (page, behavior = 'smooth') => {
      const safePage = Math.max(0, Math.min(pageCount - 1, page));
      const targetCard = cards[safePage];
      if (!targetCard) return;
      currentPage = safePage;
      isProgrammaticScroll = true;
      window.clearTimeout(programmaticScrollTimer);
      programmaticScrollTimer = window.setTimeout(() => {
        isProgrammaticScroll = false;
      }, 900);
      track.scrollTo({ left: targetCard.offsetLeft - track.offsetLeft, behavior });
      setActivePage(safePage);
    };

    const rebuildControls = () => {
      visibleCards = getVisibleCards();
      pageCount = sliderEnabled() ? Math.max(1, cards.length - visibleCards + 1) : 1;
      if (dotsContainer) {
        dotsContainer.replaceChildren();
        for (let index = 0; index < pageCount; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `customer-polaroids__dot${index === 0 ? ' is-active' : ''}`;
          dot.setAttribute('aria-label', `Show customer photo ${index + 1}`);
          dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          dot.addEventListener('click', () => goToPage(index));
          dotsContainer.appendChild(dot);
        }
        dots = Array.from(dotsContainer.children);
        dotsContainer.hidden = pageCount <= 1;
      }
      if (previousButton) previousButton.hidden = pageCount <= 1;
      if (nextButton) nextButton.hidden = pageCount <= 1;
      currentPage = 0;
      setActivePage(0);
    };

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        goToPage(currentPage - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        goToPage(currentPage + 1);
      });
    }

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', () => {
        isProgrammaticScroll = false;
      });
    }

    let scrollFrame;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        if (!sliderEnabled() || isProgrammaticScroll) return;
        currentPage = Math.max(0, Math.min(pageCount - 1, Math.round(track.scrollLeft / getStepWidth())));
        setActivePage(currentPage);
      });
    }, { passive: true });

    let isDragging = false;
    let dragMoved = false;
    let dragStartX = 0;
    let dragScrollStart = 0;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || !sliderEnabled()) return;
      isDragging = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragScrollStart = track.scrollLeft;
      track.classList.add('is-dragging');
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.setPointerCapture(event.pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      const delta = event.clientX - dragStartX;
      if (Math.abs(delta) > 3) dragMoved = true;
      track.scrollLeft = dragScrollStart - delta;
    });

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      track.style.cursor = '';
      track.style.scrollBehavior = '';
      track.style.scrollSnapType = '';
      if (dragMoved) {
        const maxScrollLeft = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScrollLeft - 4) {
          currentPage = pageCount - 1;
          isProgrammaticScroll = true;
          window.clearTimeout(programmaticScrollTimer);
          programmaticScrollTimer = window.setTimeout(() => {
            isProgrammaticScroll = false;
          }, 900);
          track.scrollTo({ left: maxScrollLeft, behavior: 'smooth' });
          setActivePage(currentPage);
        } else {
          const nearestPage = Math.max(0, Math.min(pageCount - 1, Math.round(track.scrollLeft / getStepWidth())));
          goToPage(nearestPage);
        }
      }
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        track.scrollLeft = 0;
        rebuildControls();
      }, 150);
    });

    rebuildControls();
  };

  const initializeAllPolaroidCarousels = (root = document) => {
    root.querySelectorAll('.customer-polaroids').forEach(initializePolaroidCarousel);
  };

  initializeAllPolaroidCarousels();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllPolaroidCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
